// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let MenuV5 = require("../../v5/common/Components/menu/MenuV5.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let EventLogs = require("../EventLogs.bs.js");
let FeaturesV3 = require("../featureFlipper/FeaturesV3.bs.js");
let MediaQuery = require("../common/Media/MediaQuery.bs.js");
let ReactRender = require("../utils/ReactRender.bs.js");
let UserSession = require("../common/UserSession/UserSession.bs.js");
let Avatar__Jsx3 = require("../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
let TailwindMerge = require("tailwind-merge");
let IsTouchDevice = require("is-touch-device");
let JsxRuntime = require("react/jsx-runtime");
let RequireAuthenticatedAgent = require("../../hoc/RequireAuthenticatedAgent.bs.js");
let RequireAuthenticatedClient = require("../../hoc/RequireAuthenticatedClient.bs.js");
let ClientAccess__Components__Avatar = require("../ClientAccess/components/ClientAccess__Components__Avatar.bs.js");

function ProfileDropdown$BaseMenu(props) {
  let buttonContentMobile = props.buttonContentMobile;
  let buttonContent = props.buttonContent;
  let isDesktop = MediaQuery.isDesktop();
  return JsxRuntime.jsx(MenuV5.Menu.make, {
    button: JsxRuntime.jsx(ButtonsV5.Button.make, {
      className: TailwindMerge.twMerge(["!border-none ml-[30px] !p-0 flex cursor-pointer relative !capitalize font-semibold"]),
      children: JsxRuntime.jsx("div", {
        children: buttonContentMobile !== undefined && !isDesktop ? buttonContentMobile : buttonContent,
        className: "flex flex-row items-center justify-start gap-4"
      })
    }),
    children: props.children
  });
}

let BaseMenu = {
  make: ProfileDropdown$BaseMenu
};

function ProfileDropdown$DefaultMenu(props) {
  let handleSignout = props.handleSignout;
  return JsxRuntime.jsx(ProfileDropdown$BaseMenu, {
    buttonContent: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: "Menu"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "arrow-down",
            size: 20,
            className: "text-zinc-600"
          }),
          className: "align-baseline"
        })
      ],
      className: "flex flex-row items-center justify-start gap-1.5"
    }),
    children: JsxRuntime.jsx(MenuV5.MenuItem.make, {
      onAction: () => handleSignout(),
      children: "Sign Out"
    })
  });
}

let DefaultMenu = {
  make: ProfileDropdown$DefaultMenu
};

function ProfileDropdown$ClientMenu(props) {
  let handleSignout = props.handleSignout;
  let match = UserSession.useClientInfo();
  let clientProfilePicEnabled = FeaturesV3.useFeatureFlipper("CAP_ClientRegistration") === "on";
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: JsxRuntime.jsxs(ProfileDropdown$BaseMenu, {
      buttonContent: JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          clientProfilePicEnabled ? JsxRuntime.jsx(ClientAccess__Components__Avatar.make, {}) : null,
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("span", {
                children: match.firstName + ` ` + match.lastName
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(IconV5.make, {
                  icon: "arrow-down",
                  size: 14,
                  className: "text-zinc-400"
                }),
                className: "align-baseline"
              })
            ],
            className: "flex flex-row items-center justify-start gap-1.5"
          })
        ]
      }),
      buttonContentMobile: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "arrow-down",
            size: 20,
            className: "text-zinc-600"
          }),
          className: "align-baseline"
        }),
        className: "flex flex-row items-center justify-start gap-1.5"
      }),
      children: [
        JsxRuntime.jsx(MenuV5.MenuItem.make, {
          href: "/client/account",
          children: "Account Settings"
        }),
        JsxRuntime.jsx(MenuV5.MenuItem.make, {
          onAction: () => handleSignout(),
          children: "Sign Out"
        })
      ]
    })
  });
}

let ClientMenu = {
  make: ProfileDropdown$ClientMenu
};

function ProfileDropdown$AgentMenu(props) {
  let handleSignout = props.handleSignout;
  let agent = UserSession.useAgentInfo();
  let plan = UserSession.usePlan();
  let hasMembershipRequestPermission = UserSession.useHasPermission("MEMBERSHIP_REQUESTS");
  let addQaFormDisabled = FeaturesV3.useIsAddQaFormDisabled();
  let marketingProfileSettingsEnabled = FeaturesV3.useFeatureFlipper("MarketingProfileSettings") === "on";
  let isTouch = IsTouchDevice();
  return JsxRuntime.jsxs(ProfileDropdown$BaseMenu, {
    buttonContent: JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(Avatar__Jsx3.make, {
          src: UserSession.Agent.avatarUrl(agent, undefined, undefined),
          name: UserSession.Agent.name(agent),
          size: "small"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: UserSession.Agent.name(agent)
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(IconV5.make, {
                icon: "arrow-down",
                size: 14,
                className: "text-zinc-400"
              }),
              className: "align-baseline"
            })
          ],
          className: "ml-[10px] flex flex-row items-center justify-start gap-1.5"
        })
      ]
    }),
    buttonContentMobile: JsxRuntime.jsx(Avatar__Jsx3.make, {
      src: UserSession.Agent.avatarUrl(agent, undefined, undefined),
      name: UserSession.Agent.name(agent),
      size: "small"
    }),
    children: [
      agent.tanStaff ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
          href: "/switch-chapter",
          children: "Switch chapter"
        }) : null,
      hasMembershipRequestPermission && !addQaFormDisabled ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
          href: "/admin/add-qa",
          children: "Add Qualified Agent"
        }) : null,
      UserSession.Plan.isFree(plan) || UserSession.Plan.isTrial(plan) ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
          href: "/subscribe",
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(IconV5.make, {
                  icon: "favorite",
                  size: 20,
                  className: "text-tan-gold-light"
                }),
                className: "mr-[5px] flex items-center justify-center"
              }),
              JsxRuntime.jsx("span", {
                children: UserSession.Plan.isTrial(plan) ? "Subscribe to Pro" : "Upgrade to Pro"
              })
            ],
            className: "flex flex-row items-center justify-start"
          })
        }) : null,
      ReactRender.ifTrue(JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/account/marketing_profile",
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: "Marketing Profile"
            }),
            JsxRuntime.jsx("div", {
              className: "intercom_marketing-profile-dropdown-link",
              onClick: e => {
                if (isTouch) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
              }
            })
          ],
          className: "flex items-center gap-2 "
        })
      }), marketingProfileSettingsEnabled),
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "/account",
        children: "Account Settings"
      }),
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        href: "https://intercom.help/top-agent-network",
        children: "Help Center"
      }),
      JsxRuntime.jsx(MenuV5.MenuItem.make, {
        onAction: () => handleSignout(),
        children: "Sign Out"
      })
    ]
  });
}

let AgentMenu = {
  make: ProfileDropdown$AgentMenu
};

function ProfileDropdown(props) {
  let handleSignout = props.handleSignout;
  let initState = UserSession.useInitState();
  let recordEvent = EventLogs.useRecordEventByCurrentUser();
  let handleSignout$p = () => {
    recordEvent(undefined, "Logout", undefined);
    handleSignout();
  };
  switch (initState) {
    case "Error" :
      return JsxRuntime.jsx(ProfileDropdown$DefaultMenu, {
        handleSignout: handleSignout
      });
    case "Agent" :
      return JsxRuntime.jsx(RequireAuthenticatedAgent.make, {
        children: JsxRuntime.jsx(ProfileDropdown$AgentMenu, {
          handleSignout: handleSignout$p
        })
      });
    case "Client" :
      return JsxRuntime.jsx(RequireAuthenticatedClient.make, {
        children: JsxRuntime.jsx(ProfileDropdown$ClientMenu, {
          handleSignout: handleSignout$p
        })
      });
    default:
      return null;
  }
}

let make = ProfileDropdown;

exports.BaseMenu = BaseMenu;
exports.DefaultMenu = DefaultMenu;
exports.ClientMenu = ClientMenu;
exports.AgentMenu = AgentMenu;
exports.make = make;
/* IconV5 Not a pure module */
